/* Card color swatches (settings.prod_card_swatches).
   Clicking a chip swaps the card's main image to that color's variant image. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.pswatch') : null;
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.product-block');
    if (!card) return;
    var url = btn.getAttribute('data-swatch-img');
    if (!url) return;
    card.querySelectorAll('.image__first img.rimage__image').forEach(function (img) {
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      img.src = url;
      img.classList.add('lazyloaded');
    });
    // The hover second image still shows the default color, so hide it once a
    // specific color is chosen.
    var second = card.querySelector('.image__second');
    if (second) second.style.display = 'none';
    card.querySelectorAll('.pswatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
  });
})();
